import React, { FC } from 'react';

import EventPeople from 'components/events/EventPeople';

import { useEvent } from 'components/context/EventContext';

const Djs: FC = () => {
  const { event } = useEvent();

  const djs = event?.djs;

  return <EventPeople people={djs} />;
};

export default Djs;
